<template>
  <BreadCrumbsNavbar
    :menu-pages="menuPagesReshaped"
    :is-loading="isLoading"
  />
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAppPlatform } from '@/stores/app/platform';
import BreadCrumbsNavbar from '@/components/shared/BreadCrumbsNavbar.vue';
import { libraryQueryParams } from '@/components/library/helpers';

// Router
const route = useRoute();

defineProps({
  isLoading: { type: Boolean, default: false },
});

const queryParams = (toMode) => libraryQueryParams(toMode, route);

const menuPagesReshaped = computed(() => useAppPlatform().dashboardNavLinks
  .map((menuPage) => ({
    ...menuPage,
    links: menuPage.links.map((link) => ({
      ...link,
      query: queryParams(link.to),
    })),
  })));
</script>
